<!-- eslint-disable vuejs-accessibility/form-control-has-label -->
<template>
  <div class="custom-checkbox">
    <input
    class="pointer"
    type="checkbox"
    v-model="isChecked"
    @change="$emit('change', isChecked)" />
    <dx-text>{{ label }}</dx-text>
  </div>
</template>

<script>
export default {
  name: 'dx-checkbox',

  props: {
    label: String,
    modelValue: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isChecked: {
      get() {
        return this.modelValue;
      },
      set(newValue) {
        this.$emit('update:modelValue', newValue);
      },
    },
  },
};
</script>

<style>
.custom-checkbox {
  display: flex;
  align-items: center;
}

.custom-checkbox input[type="checkbox"] + label {
  position: relative;
  padding-left: 25px;

}

.custom-checkbox input[type="checkbox"] + label::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 2px solid #333;
  border-radius: 4px;
}

.custom-checkbox input[type="checkbox"]:checked + label::before {
  background-color: #007bff;
  border-color: #007bff;
}

.pointer {
  cursor: pointer
}
</style>
